// ==========================
// Version 1 — auth/registrationConsent.js
// - Defines the legal document versions accepted during registration
// - Records an authenticated, server-timestamped consent receipt in Firestore
// ==========================
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const TERMS_VERSION = "2026-08-13";
export const PRIVACY_VERSION = "2026-08-13";

export function hasRequiredRegistrationConsent({ ageConfirmed, legalAccepted }) {
  return ageConfirmed === true && legalAccepted === true;
}

export async function recordRegistrationConsent(user, acceptanceMethod) {
  if (!user?.uid) {
    throw new Error("A signed-in user is required to record registration consent.");
  }
  if (!["email", "google"].includes(acceptanceMethod)) {
    throw new Error("A valid registration method is required.");
  }

  await setDoc(
    doc(db, "users", user.uid),
    {
      legal: {
        termsVersion: TERMS_VERSION,
        privacyVersion: PRIVACY_VERSION,
        acceptedAt: serverTimestamp(),
        ageConfirmed: true,
        acceptanceMethod,
      },
    },
    { merge: true }
  );
}

// ==========================
// End Version 1 — auth/registrationConsent.js
// ==========================
